import PubSub from "pubsub-js";

import PubSubTopics from "../constants/pubSubTopics";
import nativeCommsBroadcaster, { messageTypes as nativeCommsBroadcastMessageTypes } from "./nativeCommsBroadcaster";
import buildNativeCommsReceiver from "./nativeCommsReceiver";

export { isNativeCommsInstalled, messageTypes as nativeCommsBroadcastMessageTypes } from "./nativeCommsBroadcaster";
export { default as nativeCommsMessageTypes } from "./nativeCommsMessageTypes";

import { isDataLoadedOperations } from "../modules/isDataLoaded";
import { welcomeOperations } from "../modules/welcome";
import userAgent from "../utils/userAgent";
import redirectConsoleLog from "./redirectConsoleLog";
//#!if ENV !== "production"
// import registerScreenshotCalls from "./registerScreenshotCalls";
//#!endif

export default store => {
  // Attach the nativeCommsReceiver to the window so that we know where
  // to access it
  window.nativeCommsReceiver = buildNativeCommsReceiver(store);

  // When an externalAction is received, dispatch it to the main redux store
  PubSub.subscribe(PubSubTopics.externalActionReceived, (msg, data) => {
    store.dispatch(data);
  });

  // When a welcomeAction is received, dispatch it to the welcome redux store
  PubSub.subscribe(PubSubTopics.welcomeActionReceived, (msg, data) => {
    store.dispatch(data);
  });

  // When a sendNativeMessage is received, send it out via the nativeCommsBroadcaster
  PubSub.subscribe(PubSubTopics.sendNativeMessage, (msg, data) => {
    nativeCommsBroadcaster(data);
  });

  // PubSub.subscribe(PubSubTopics.welcomeScreenHidden, (_msg, _data) => {
  //   store.dispatch(welcomeOperations.hideWelcome());
  // });

  // Let the native application know that we are setup and ready to receive data
  const data = {
    msg: nativeCommsBroadcastMessageTypes.INITIALIZED
  };
  PubSub.publish(PubSubTopics.sendNativeMessage, data);

  redirectConsoleLog();

  // If this is running in the browser, show the welcome screen
  //#!if iOS === true
// if (userAgent.isUnknownApp() || userAgent.isScreenshotApp()) {
// store.dispatch(welcomeOperations.showWelcome());
// store.dispatch(isDataLoadedOperations.setDataIsLoaded());
// }
  //#!endif

  // When in dev mode, register screenshot calls
  //#!if ENV !== "production"
// if (userAgent.isScreenshotApp()) {
// registerScreenshotCalls();
// }
  //#!endif
};
